import { palette, shape, typography } from "@src/core/styles";
import styled from "styled-components";
import type { TabProps, ProgressBarProps } from "./load-file.types";

export const FormTitle = styled.div`
  ${typography.headline_small};
  margin-bottom: 24px;
`;

export const DescriptionTextWrapper = styled.div`
  margin-top: 8px;
`;

export const DescriptionText = styled.div`
  ${typography.body_small_regular}
`;

export const StyledLabel = styled.label`
  & > .MuiButton-root {
    padding: 10px 16px;
    text-transform: none;
    ${typography.label_large};
    color: ${palette.colors.green_base};
    border-radius: ${shape.rounding.XXXL};
    border: ${palette.border.outline};

    & svg {
      path {
        fill: ${palette.colors.green_base};
      }
    }
  }
  & > .MuiButton-root:hover {
    background-color: rgba(27, 109, 36, 0.08);
    border: ${palette.border.outline};
  }
`;

export const UploadFileWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const StyledUploadedFile = styled.div`
  ${typography.body_large_regular};
`;

export const FooterForm = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
`;

export const TabGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const Tab = styled.div<TabProps>`
  ${typography.label_large};
  padding: 6px 12px;
  border-radius: 8px;
  background-color: ${({ active }) =>
    active === "true"
      ? `${palette.colors.secondary_container}`
      : "transparent"};
  border: ${({ active }) =>
    active === "true"
      ? `1px solid ${palette.colors.secondary_container}`
      : `${palette.border.outline}`};
  cursor: pointer;
`;

export const StyledLinearProgress = styled.div<ProgressBarProps>`
  margin-top: 16px;
  opacity: ${({ value }) => (value === 0 ? 0 : 1)};

  & div > .MuiLinearProgress-root {
    background-color: ${palette.colors.surface_container_highest};
    & > .MuiLinearProgress-barColorPrimary {
      background-color: ${palette.colors.green_base};
    }
  }
`;
